const FooterData = {
    CompanyWidget: [
        {
            id: 1,
            title: "Get In Touch",
            description: "Don’t miss any updates of our new services and products.",
        }
    ],
    AboutWidget: [
        {
          id: 1,
          title: "Download",
          menuItems: [
              {
                id: 1,
                url: '#',
                text: 'Company',
              },
              {
                id: 2,
                url: '#',
                text: 'Android App',
              },
              {
                id: 3,
                url: '#',
                text: 'ios App',
              },
              {
                id: 4,
                url: '#',
                text: 'Desktop',
              },
              {
                id: 5,
                url: '#',
                text: 'Projects',
              },
              {
                  id: 6,
                  url: '#',
                  text: 'My tasks',
              },
          ],
      },
      {
            id: 2,
            title: "Help",
            menuItems: [
                {
                  id: 1,
                  url: '#',
                  text: 'FAQ',
                },
                {
                  id: 2,
                  url: '#',
                  text: 'Term & conditions',
                },
                {
                  id: 3,
                  url: '#',
                  text: 'Reporting',
                },
                {
                  id: 4,
                  url: '#',
                  text: 'Documentation',
                },
                {
                  id: 5,
                  url: '#',
                  text: 'Support Policy',
                },
                {
                    id: 6,
                    url: '#',
                    text: 'Privacy',
                  },
            ],
        },
    ],
    termsCondition: [
      {
          id: 1,
          title: "Team Solutions",
          menuItems: [
            {
              id: 1,
              url: '#',
              text: 'Support',
            },
            {
              id: 2,
              url: '#',
              text: 'Sales',
            },
            {
              id: 3,
              url: '#',
              text: 'Report Abuse',
            },
            {
              id: 4,
              url: '#',
              text: 'System Status',
            }
        ],
      }
    ],
    SocialLinks: [
        {
            id: 1,
            title: "Team Solutions",
            menuItems: [
                {
                  id: 1,
                  url: 'https://www.facebook.com/everpay',
                  icon: 'ti-facebook',
                },
                {
                  id: 2,
                  url: 'https://twitter.com/everpay',
                  icon: 'ti-twitter-alt',
                },
                {
                  id: 3,
                  url: 'https://github.com/everpay',
                  icon: 'ti-github-alt',
                },
                {
                  id: 4,
                  url: ' https://www.instagram.com/everpay',
                  icon: 'ti-instagram-alt',
                },
                // {
                //   id: 4,
                //   url: '#',
                //   icon: 'ti-pinterest',
                // }
            ]
        }
    ],
    socialIcon:[
      {
        id: 1,
        url: 'https://www.facebook.com/everpay',
        icon: 'ti-facebook',
      },
      {
        id: 2,
        url: 'https://twitter.com/everpay',
        icon: 'ti-twitter-alt',
      },
      {
        id: 3,
        url: 'https://github.com/everpay',
        icon: 'ti-github',
      },
      {
        id: 4,
        url: 'https://www.instagram.com/everpay',
        icon: 'ti-instagram',
      }
    ],
    copywrite:"Copyright © 2023 Everpay Corporation. All rights reserved.",
    TestimonialText: [
      {
        id: 1,
        image: "new/member_01.jpg",
        description: "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
        authorName: "Phillip Anthropy",
        authorPost: "UI/UX designer", 
      },
      {
        id: 2,
        image: "new/member_01.jpg",
        description: "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
        authorName: "Phillip Anthropy",
        authorPost: "UI/UX designer", 
      },
      {
        id: 3,
        image: "new/member_01.jpg",
        description: "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
        authorName: "Phillip Anthropy",
        authorPost: "UI/UX designer", 
      },
      {
        id: 4,
        image: "new/member_01.jpg",
        description: "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
        authorName: "Phillip Anthropy",
        authorPost: "UI/UX designer", 
      }
    ],
    aboutLinks: [
      {
        id: 1,
        url: '#',
        item: 'Developer',
      },
      {
        id: 2,
        url: '#',
        item: 'Blog',
      },
      {
        id: 3,
        url: '#',
        item: 'Investor',
      },
      {
        id: 4,
        url: '#',
        item: 'Sitemap',
      },
      {
        id: 5,
        url: '#',
        item: 'Jobs',
      }
    ],
    helpLinks: [
      {
        id: 1,
        url: '#',
        item: 'Help and Contact',
      },
      {
        id: 2,
        url: '#',
        item: 'Fees',
      },
      {
        id: 3,
        url: '#',
        item: 'Security',
      },
      {
        id: 4,
        url: '#',
        item: 'App',
      },
      {
        id: 5,
        url: '#',
        item: 'Shop',
      }
    ],
    PrivacyLinks: [
      {
        id: 1,
        url: '#',
        item: 'Privacy Policy',
      },
      {
        id: 2,
        url: '#',
        item: 'Legal Agreement',
      },
      {
        id: 3,
        url: '#',
        item: 'Feedback',
      }
    ],
    about: [
      {
        id: 1,
        url: '#',
        text: 'Company',
      },
      {
        id: 2,
        url: '#',
        text: 'Leadership',
      },
      {
        id: 3,
        url: '#',
        text: 'Diversity',
      },
      {
        id: 4,
        url: '#',
        text: 'Jobs',
      },
      {
        id: 5,
        url: '#',
        text: 'Press',
      },
      {
        id: 6,
        url: '#',
        text: 'Wavelength',
      },
    ],
    Solution: [
      {
        id: 1,
        url: '#',
        text: 'Project Management',
      },
      {
        id: 2,
        url: '#',
        text: 'Agile',
      },
      {
        id: 3,
        url: '#',
        text: 'Task Management',
      },
      {
        id: 4,
        url: '#',
        text: 'Reporting',
      },
      {
        id: 5,
        url: '#',
        text: 'Work Tracking',
      },
      {
        id: 6,
        url: '#',
        text: 'See All Uses',
      },
    ],
    teamSolution: [
      {
        id: 1,
        url: '#',
        text: 'Engineering',
      },
      {
        id: 2,
        url: '#',
        text: 'Designers',
      },
      {
        id: 3,
        url: '#',
        text: 'Sales',
      },
      {
        id: 4,
        url: '#',
        text: 'Developers',
      },
      {
        id: 5,
        url: '#',
        text: 'Marketing',
      },
      {
        id: 6,
        url: '#',
        text: 'See All team',
      },
    ],
    whyUs: [
      {
        id: 1,
        url: '/industries-served',
        text: 'Industries Served',
      },
      {
        id: 2,
        url: '/services',
        text: 'Services & Solutions',
      },
      {
        id: 3,
        url: '/security',
        text: 'Compliance & Security',
      },
      {
        id: 4,
        url: '/pricing',
        text: 'Transparent Pricing',
      },
    ],
    whatWedo: [
      {
        id: 1,
        url: '/card-processing',
        text: 'Card Processing',
      },
      {
        id: 2,
        url: '/direct-debits',
        text: 'Direct Debits',
      },
      {
        id: 3,
        url: '/coin-payments',
        text: 'Crypto Processing',
      },
      {
        id: 4,
        url: '/subscription-commerce',
        text: 'Subscription Commerce',
      },
    ],
    theCompany: [
      {
        id: 1,
        url: '/about-us',
        text: 'About us',
      },
      {
        id: 2,
        url: '/contact-us',
        text: 'Contact us',
      },
      {
        id: 3,
        url: '/careers',
        text: 'Jobs We\'re hiring!',
      },
      {
        id: 4,
        url: '/become-a-partner',
        text: 'Become a partner',
      },
    ],
    resources: [
      {
        id: 1,
        url: '//support.everpayinc.com',
        text: 'Help & Support',
      },
      {
        id: 2,
        url: 'https://gate.everpayinc.com/docs',
        text: 'API Documentation',
      },

      {
        id: 3,
        url: 'https://developers.everpayinc.com',
        text: 'Developer Portal',
      },
      {
        id: 4,
        url: 'https://status.everpayinc.com',
        text: 'System Status',
      },
    ],
};
export default FooterData;
